import React from 'react';
import styles from './styles.module.css';
import { useFormik } from 'formik';
import { Input } from '../Auth/Components';
import { useDispatch, useSelector } from 'react-redux';
import { registerUser } from '../../actions/auth';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { version } from '../../assets/const';
export default function Register() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { token, registerError } = useSelector((state) => state.auth);

  const { values, handleChange, handleSubmit, handleBlur } = useFormik({
    initialValues: {
      username: '',
      email: '',
      password: '',
      confirmPassword: '',
    },
    onSubmit: (values) => dispatch(registerUser(values, navigate)),
  });

  if (token) {
    return <Navigate to="/" />;
  }

  return (
    <div className={styles.wrapper}>
      <header className={styles.header}>
        <h1>NinSeo</h1>
      </header>

      <main>
        <form onSubmit={handleSubmit} className={styles.form}>
          <h1>Регистрация</h1>

          <Input
            name="username"
            value={values.username}
            placeholder="Логин"
            onChange={handleChange}
            onBlur={handleBlur}
          />

          <Input
            name="email"
            type="email"
            value={values.email}
            placeholder="E-mail"
            onChange={handleChange}
            onBlur={handleBlur}
          />

          <Input
            name="password"
            type="password"
            value={values.password}
            placeholder="Пароль"
            onChange={handleChange}
            onBlur={handleBlur}
          />

          <Input
            name="confirmPassword"
            type="password"
            value={values.confirmPassword}
            placeholder="Подтвердите пароль"
            onChange={handleChange}
            onBlur={handleBlur}
          />

          <button type="submit">Создать аккаунт</button>

          {registerError && <p className={styles.error}>{registerError}</p>}
        </form>

        <Link to="/auth" className={styles.link}>
          Уже есть аккаунт? Войти
        </Link>
      </main>

      <footer className={styles.footer}>
        <div>
          <a href="https://nintegra.ru" target="_blank" rel="noreferrer">
            <span>www.nintegra.ru</span>
          </a>
        </div>
        <div>
          <span>V {version}</span>
        </div>
      </footer>
    </div>
  );
}
